import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const deselect: SxStyle = {
  cursor: 'pointer',
};

export const summaryContent: SxStyle = {
  width: '100%',
};

export const count: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  color: (p) => p.palette.primary[300],
};

export const checkIcon: SxStyleFunc<boolean> = (checked) => ({
  display: checked ? 'inline-block' : 'none',
});
